import isUndefined from 'lodash/isUndefined';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {hideMenu, showMenu, toggleMenu} from '../actions/mainMenu';
import {logger} from './logger';


export const epics = [
  onToggleMenu,
];

onToggleMenu.$inject = [
  '$ionicSideMenuDelegate',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onToggleMenu(action$, store, dependencies) {
  return action$.ofType(hideMenu.TYPE, showMenu.TYPE, toggleMenu.TYPE)
    .do(action => {
      const $ionicSideMenuDelegate = dependencies.$ionicSideMenuDelegate;

      switch (action.type) {
        case hideMenu.TYPE:
          return updateMenu($ionicSideMenuDelegate, false);

        case showMenu.TYPE:
          return updateMenu($ionicSideMenuDelegate, true);

        case toggleMenu.TYPE:
          return updateMenu($ionicSideMenuDelegate);

      }
    })
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onToggleMenu'));
}

/**
 * @param $ionicSideMenuDelegate
 * @param {Boolean} [show]
 */
function updateMenu($ionicSideMenuDelegate, show) {
  if (isUndefined(show) || (!!$ionicSideMenuDelegate.isOpenLeft()) !== show) {
    $ionicSideMenuDelegate.toggleLeft();
  }
}



// WEBPACK FOOTER //
// ./src/js/app/epics/onToggleMainMenu.js